'use strict';

const getUpdatedURLWithParams = (urlParams, paramsToRemove, skipHash) => {
    if (!urlParams) {
        return;
    }

    const search = location.search.substring(1);
    const params = search == '' ? {}
        : JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
            function(key, value) {return key === '' ? value : decodeURIComponent(value);});

    // Overwrite search object with new key / values from urlParams
    if (urlParams) {
        Object.assign(params, urlParams);
    }

    if (paramsToRemove) {
        paramsToRemove.forEach((key) => {
            delete params[key];
        });
    }

    // Construct new URL and replace state
    return location.origin + location.pathname + '?' + $.param(params) + (!skipHash ? location.hash : '');
};

module.exports = getUpdatedURLWithParams;
